<template>
  <c-loading-area :loading="loading">
    <v-card-title>
      {{ $t('page.makePayment.selectParty.title') }}
    </v-card-title>
    <v-card-subtitle>
      {{ $t('page.makePayment.selectParty.subTitle') }}
    </v-card-subtitle>
    <v-card-text>
      <cutout-area v-if="noResults" class="mt-6">
        {{ $t('global.noneFound') }}
      </cutout-area>
      <v-simple-table v-else>
        <thead>
          <tr>
            <th style="width:1px"></th>
            <th>{{ $t('page.makePayment.selectParty.partyName') }}</th>
            <th>{{ $t('page.makePayment.selectParty.partyRole') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item) in bean.partySearchResults" :key="item.casePartyUUID">
            <td style="padding-right:0 !important">
              <v-radio-group v-model="bean.selections.casePartyUUID" class="ma-0 pa-0" hide-details>
                <v-radio class="ma-0 pa-0" :value="item.casePartyUUID"/>
              </v-radio-group>
            </td>
            <td>{{ item.sortName }}</td>
            <td>{{ item.partySubTypeName }}</td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card-text>
    <v-card-actions class="mt-10 justify-end">
      <c-btn type="primary" @click="save">
        {{ $t('global.continue') }}
      </c-btn>
    </v-card-actions>
  </c-loading-area>
</template>

<script>
import WorkflowStepMixin from '@/mixins/workflowStep';
import CutoutArea from '@components/support/CutoutArea';
import { scrollTo } from '@/application/utility';
import { useApplicationStore } from '@/stores/applicationStore';
import { useUserStore } from '@/stores/userStore';

import axios from 'axios';
import _ from 'lodash';

const applicationStore = useApplicationStore();
const userStore = useUserStore();

export default {
  mixins: [ WorkflowStepMixin ],
  components: { CutoutArea },
  computed: {
    isSingleCourtMode () {
      return applicationStore.isSingleCourtMode;
    },
    noResults () {
      return this.bean.partySearchResults.length <= 0;
    }
  },
  methods: {
    loadData () {
      // check if verified case party
      let verifiedPartyPromise = Promise.resolve({ data: false });
      if (userStore.hasSession)
      {
        let selectedCase = _.find(this.bean.caseSearchResults, ['caseInstanceUUID', this.bean.selections.caseInstanceUUID]);
        let verifyURL = this.$cove.getAPI({
          name: 'api.case.verifiedCaseParty',
          params: {
            courtID: applicationStore.getCourtByExternalID(selectedCase.courtID).resourceID,
            caseUUID: this.bean.selections.caseInstanceUUID }
        });
        verifiedPartyPromise = axios.get(verifyURL);
      }

      // get parties
      let partyUrl = this.$cove.getAPI({ name: 'api.party.payments', query: { caseInstanceUUID: this.bean.selections.caseInstanceUUID } });
      let casePartiesPromise = axios.get(partyUrl);

      return Promise.all([verifiedPartyPromise, casePartiesPromise])
        .then(([verifiedPartyResponse, casePartiesResponse]) => {
          this.bean.isVerifiedCaseParty = verifiedPartyResponse.data;

          if (!_.isNil(casePartiesResponse.data) && casePartiesResponse.data.length > 0) {
            this.bean.partySearchResults = _.sortBy(casePartiesResponse.data, 'sortName');
            if (this.bean.partySearchResults.length === 1) {
              this.bean.selections.casePartyUUID = this.bean.partySearchResults[0].casePartyUUID;
            }
          }
        });
    },
    validate () {
      this.$cove.validation.clear();
      if (_.isNil(this.bean.selections.casePartyUUID)) {
        this.$cove.validation.addError('casePartyUUID', 'page.makePayment.selectParty.validation.selectParty');
      }
      return !this.$cove.validation.hasErrors();
    },
    save () {
      let isValid = this.validate();
      if (!isValid)
      {
        scrollTo(this.CONST.ERROR_CONTAINER_SELECTOR);
      }
      else
      {
        this.$emit('save', this.bean);
      }
    }
  }
};
</script>
